export function ProductCardSkeleton() {
    return (
        <div className="cs-card p-0 animate-pulse" data-testid="skeleton-product-card">
            <div className="aspect-[4/3] bg-cs-steel/20" />
            <div className="p-5 space-y-3">
                <div className="h-3 w-24 bg-cs-steel/30" />
                <div className="h-5 w-4/5 bg-cs-steel/30" />
                <div className="h-3 w-full bg-cs-steel/20" />
                <div className="h-3 w-3/5 bg-cs-steel/20" />
                <div className="h-8 w-full bg-cs-steel/20 mt-4" />
            </div>
        </div>
    );
}

export function ProductGridSkeleton({ count = 6 }) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.from({ length: count }).map((_, i) => (
                <ProductCardSkeleton key={i} />
            ))}
        </div>
    );
}

export function BlogCardSkeleton() {
    return (
        <div className="cs-card animate-pulse" data-testid="skeleton-blog-card">
            <div className="aspect-[16/10] bg-cs-steel/20" />
            <div className="p-5 space-y-2">
                <div className="h-3 w-24 bg-cs-steel/30" />
                <div className="h-5 w-4/5 bg-cs-steel/30" />
                <div className="h-3 w-full bg-cs-steel/20" />
            </div>
        </div>
    );
}

export function LoadingScreen() {
    return (
        <div className="min-h-[60vh] flex items-center justify-center" data-testid="loading-screen">
            <div className="flex flex-col items-center gap-3">
                <div className="w-2 h-2 bg-cs-orange cs-pulse-dot" />
                <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-cs-steel">
                    Loading
                </span>
            </div>
        </div>
    );
}

export default LoadingScreen;
